import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

import { getAuthHeader, GetParams, PostParams } from './common.service';

import { AUTH_API_ENDPOINT } from '~configs';

const axiosClient = applyCaseMiddleware(
  axios.create({
    baseURL: AUTH_API_ENDPOINT,
    // https://github.com/axios/axios/issues/5058#issuecomment-1272107602
    // Example: Params { a: ['b', 'c']}
    // From (by default - false) 'a[]=b&a[]=c'
    // To (by null) 'a=b&a=c'
    paramsSerializer: {
      indexes: null, // by default: false
    },
  }),
  {
    ignoreHeaders: true,
  },
);

export const getAuthRequest = async <T>({
  path,
  config,
  customHeader,
  params,
  ignoreAuthHeader,
}: GetParams<T>) => {
  const authHeader = await getAuthHeader(ignoreAuthHeader);
  const response = await axiosClient.get(`/${path}`, {
    headers: {
      Accept: 'application/json',
      ...authHeader,
      ...customHeader,
    },
    params,
    ...config,
  });
  return response.data;
};

export const postAuthRequest = async <T>({
  path,
  config,
  customHeader,
  data,
  ignoreAuthHeader,
}: PostParams<T>) => {
  const authHeader = await getAuthHeader(ignoreAuthHeader);
  return axiosClient.post(`/${path}`, data, {
    headers: {
      Accept: 'application/json',
      ...authHeader,
      ...customHeader,
    },
    ...config,
  });
};

export const putAuthRequest = async <T>({
  path,
  config,
  customHeader,
  data,
  ignoreAuthHeader,
}: PostParams<T>) => {
  const authHeader = await getAuthHeader(ignoreAuthHeader);
  return axiosClient.put(`/${path}`, data, {
    headers: {
      Accept: 'application/json',
      ...authHeader,
      ...customHeader,
    },
    ...config,
  });
};

export const patchAuthRequest = async <T>({
  path,
  config,
  customHeader,
  data,
  ignoreAuthHeader,
}: PostParams<T>) => {
  const authHeader = await getAuthHeader(ignoreAuthHeader);
  return axiosClient.patch(`/${path}`, data, {
    headers: {
      Accept: 'application/json',
      ...authHeader,
      ...customHeader,
    },
    ...config,
  });
};

export const delAuthRequest = async <T>({
  path,
  config,
  customHeader,
  ignoreAuthHeader,
}: GetParams<T>) => {
  const authHeader = await getAuthHeader(ignoreAuthHeader);
  return axiosClient.delete(`/${path}`, {
    headers: {
      Accept: 'application/json',
      ...authHeader,
      ...customHeader,
    },
    ...config,
  });
};
